module.exports = __webpack_public_path__ + "img/pic2.f3d3d82a.jpg";